import React from 'react';
import { useRemoteBool } from '@mrkt/features/RemoteConfig';
import { Switch, Route } from 'react-router-dom';
import { Banner } from '@spotify-internal/encore-creator-web';
import { spacer, breakpoint } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { appMaxWidth } from '../../shared/styles/variables';
import { useCurrentUser } from '../currentUser';

function useRemoteConfigMigrationWelcomeBannerRollout() {
  return useRemoteBool('analytics-migration-onboarding');
}

const BannerWrapper = styled.div`
  @media (min-width: ${breakpoint.screenSmMin}) {
    margin-bottom: ${spacer.spacer24};
    margin-left: auto;
    margin-right: auto;
    padding-left: ${spacer.spacer48};
    padding-right: ${spacer.spacer48};
    max-width: ${appMaxWidth};
    width: 100%;

    & > * {
      border-radius: '4px';
    }
  }
`;

export function AnalyticsMigrationOnboarding() {
  const currentUser = useCurrentUser();
  const remoteConfigMigrationWelcomeBannerRollout = useRemoteConfigMigrationWelcomeBannerRollout();

  if (
    currentUser?.hasLabelOnlyAccess &&
    remoteConfigMigrationWelcomeBannerRollout
  ) {
    return (
      <Switch>
        <Route path="/artist/:artistId/(profile|audience|music/songs)">
          <BannerWrapper>
            <Banner variant={Banner.announcement}>
              New to Spotify for Artists? Learn how to pitch songs, see stats,
              find artists you manage, and more {'\u2013'} all in our
              <a
                href="http://spoti.fi/S4ATeamOnboarding"
                target="_blank"
                rel="noopener noreferrer"
              >
                {' '}
                onboarding guide
              </a>
              .
            </Banner>
          </BannerWrapper>
        </Route>
      </Switch>
    );
  }

  return null;
}
